import useRect from './use-rect';

export { useRect };

export default useRect;
